module.exports = __webpack_public_path__ + "img/tada.48854faf.gif";